import { render } from "./EditWeight.vue?vue&type=template&id=6f83f001&scoped=true"
import script from "./EditWeight.vue?vue&type=script&lang=js"
export * from "./EditWeight.vue?vue&type=script&lang=js"

import "./EditWeight.vue?vue&type=style&index=0&id=6f83f001&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f83f001"]])

export default __exports__